/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Choose_How_To_Reach_UsInputs */

const en_mobile_choose_how_to_reach_us = /** @type {(inputs: Mobile_Choose_How_To_Reach_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose how to reach us`)
};

const es_mobile_choose_how_to_reach_us = /** @type {(inputs: Mobile_Choose_How_To_Reach_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige cómo contactarnos`)
};

/**
* | output |
* | --- |
* | "Choose how to reach us" |
*
* @param {Mobile_Choose_How_To_Reach_UsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_choose_how_to_reach_us = /** @type {((inputs?: Mobile_Choose_How_To_Reach_UsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Choose_How_To_Reach_UsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_choose_how_to_reach_us(inputs)
	return en_mobile_choose_how_to_reach_us(inputs)
});